jQuery(document).ready(function ($) {
  var tag_link = $('.catalogues__tags-link');
  tag_link.click(function (event) {
    tag_link.removeClass('active');
    //console.log(this);
    var str = $(this).attr('class');
    //current_class.addClass('active');
    //console.log(str);
    var type = str.split(' ');
    //console.log(type[1]);
    var active_type = '.'.concat(type[1]);
    //console.log(active_type);
    $(active_type).addClass('active');
  });
});
